import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { RoleHeader, Role, DeleteRole, AddEditRole } from '../components'
import { globalGetService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { downloadFileType } from '../../../utils'
import RoleBasedAccess from '../../../utils/RoleBasedAccess';
import { Pagination, FilterComponent, STableLoader, PageLoader, EmptyCollection } from '../../shared_elements';
import { SettingsNavWrapper } from '../../elements'
import { Table, TableBody, Paper, Grid, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { rolesFilters } from '../';
import { trackActivity } from '../../../utils/mixpanel';
const Roles = ({}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [deleteRole, setDeleteRole] = useState({modal:false, role:null, item:null})
    const [addEditRole, setAddEditRole] = useState({modal:false, mode:'', app:null, item:{id:'', name:'', application:[]}})
    const [rolesInfo,setRolesInfo] = useState({list:[], pagination:{}});
    const [roleUsers, setRoleUsers] = useState([]);
    const [allApplications, setAllApplications] = useState([]);
    const [alterOptions, setAlterOptions] = useState([]);
    const [roleProfilesInfo,setRoleProfilesInfo] = useState([]);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    useEffect(() => {
        getRoles({...filter, per_page:50}, 'skeletonLoader');
        getAllApplications();
        getRoleProfiles();
        trackActivity('Console Management', { page_title: 'Roles Profile', event_type: 'Page Visit', event_desc: 'Roles Profile Page Visited' })
    },[]);
    const getAllApplications = () => {
        globalGetService(`console/application_dropdown/`,{all:true})
        .then(response => {
            if(checkApiStatus(response)){
                setAllApplications(response.data.data)
            }
        })
    }
    const getRoleProfiles = (query={}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`console/group_profile/`,{...query, all:true})
        .then(response => {
            if(checkApiStatus(response)){
                setRoleProfilesInfo(response.data.data);
                delete query.sort
                delete query.sort_by
                setFilter(query);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        });
    }
    const getRoles = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`console/roles/`, query)
        .then(response => {
            if(checkApiStatus(response)){
                setRolesInfo(response.data.data);
                delete query.page
                delete query.per_page
                delete query.sort
                delete query.sort_by
                setFilter(query);
            }else{

            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        });
    }
    const getRole = (role, mode) => {
        setLoading(true)
        globalGetService(`console/role/${role.application.id}/${role.id}/`)
        .then(response => {
            if(checkApiStatus(response)){
                setAddEditRole({modal:true, mode:mode, app: role.application, item:response.data.data});
                if(mode === 'view'){
                    setRoleUsers(role.users);
                }
                setLoading(false)
            }else{

            }
        })
    }
    const getAlternateRoles = (item) => {
        setDeleteRole({modal:true,item});
        if(item.users.length){
            globalGetService('console/roles-dropdown/')
            .then(response => {
                if(checkApiStatus(response)){
                    let options = response.data.data.filter(app => (app.application.id === item.application.id && app.name !== item.name))
                    setAlterOptions(options);
                }else{

                }
            });
        }
    }
    const onDeleteRole = () => {
        let payload = {}
        if(deleteRole.item.users.length){
            if(!deleteRole.role){
                enqueueSnackbar('Please select the Alternate Role', { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
                return
            }else{
                payload = {alternate_group_id:deleteRole.role.id}
            }
        }
        globalDeleteService(`console/role/${deleteRole.item.application.id}/${deleteRole.item.id}/`,payload)
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                setDeleteRole({modal:false, role:null, item:null});
                getRoles({...filter, per_page:50}, 'pageLoader');
                trackActivity('Console Management', { page_title: 'Roles', item_type: 'Delete', event_type:'Role(s) Deleted', event_desc: 'Role(s) Deleted Successfully', application_id: deleteRole.item.application.id, item_id: deleteRole.item.id})
            }else{
                enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
            }
        })
    }
    let filterOptions = Object.assign({}, rolesFilters);
    filterOptions = {
        ...filterOptions,
        application_id:{
            ...filterOptions.application_id,
            options:allApplications
        },
        group_profile_id:{
            ...filterOptions.group_profile_id,
            options:roleProfilesInfo
        }

    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getRoles({ ...filter, ...sortQuery, page: 1, per_page: rolesInfo?.pagination?.per_page }, 'pageLoader');
    }
    return(
        <section className='roles-management' style={{margin:'24px 0 0px 276px'}}>
            <SettingsNavWrapper />
            <div>
                { skeletonLoader ? <STableLoader count={6} size={9} />:
                    <>
                        <Paper elevation={0} className='console-paper' style={{padding:'5px 10px', marginBottom: "2px"}}>
                            <Grid container spacing={1} alignItems='center'>
                                <Grid item md={8}>
                                    <FilterComponent 
                                        filter={filter} 
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getRoles({...applyFilter, page:1, per_page:rolesInfo.pagination.per_page}, 'pageLoader')}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <ul className='list-inline' style={{float:'right'}}>
                                        { checkPermission('settings', 'custom_roles', 'C') ?
                                            <li className='list-inline-item'>
                                                <Button onClick={()=>setAddEditRole({modal:true, app:null, item:null})} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} />Add Role</Button>
                                            </li>:null
                                        }
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper square>
                            <div style={{height: !rolesInfo.list.length ? `${window.innerHeight-125}px` :`${window.innerHeight-175}px`,overflow:'auto'}}>
                                <Table className='mui-table-format hovered-table' stickyHeader>
                                    <RoleHeader createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                    <TableBody>
                                        {rolesInfo.list.length > 0 && rolesInfo.list.map((item,index) =>
                                            <Role 
                                                item={item}
                                                key={index}
                                                rolesInfo={rolesInfo}
                                                onView={() => getRole(item, 'view')}
                                                onEdit={() => getRole(item, 'edit')}
                                                onDelete={() => getAlternateRoles(item)}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                                {!rolesInfo?.list?.length ? <div style={{textAlign:'center'}}><EmptyCollection title="No Records found" /></div>:null}
                            </div>
                            <Paper square>
                                <Pagination
                                    pagination={rolesInfo.pagination}
                                    onChangePage={(event, newPage) => getRoles({ page: newPage + 1, per_page: rolesInfo.pagination.per_page, ...filter, ...sortInfo }, 'pageLoader')}
                                    onChangeRowsPerPage={(event) => getRoles({ page: 1, per_page: event.target.value, ...filter, ...sortInfo }, 'pageLoader')}
                                />
                            </Paper>
                        </Paper>
                    </>
                }
            </div>
            { addEditRole.modal ? 
                <AddEditRole 
                    addEditRole={addEditRole}
                    toggleModalFn={()=> {setAddEditRole({modal:false, mode:'', app:null, item:null}); setRoleUsers([])}}
                    getResponseBack={() => getRoles({...filter, per_page:rolesInfo.pagination.per_page}, 'pageLoader')}
                    roleUsers={roleUsers}
                />:null
            }
            { deleteRole.modal ?
                <DeleteRole 
                    alterOptions={alterOptions}
                    deleteRole={deleteRole}
                    modal={deleteRole.modal}
                    onChangeRole={(value) => setDeleteRole({...deleteRole, role:value})}
                    onDeleteRole={onDeleteRole}
                    toggleModalFn={() => setDeleteRole({modal:false, item:null})}
                    isLoading={isLoading}
                />:null
            }
            { isLoading ? <PageLoader />:null }
        </section>
    )
}
export default RoleBasedAccess(Roles,['settings','custom_roles','R']);